import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M5.66602 8.16699C6.12625 8.16699 6.49935 7.7939 6.49935 7.33366C6.49935 6.87342 6.12625 6.50033 5.66602 6.50033C5.20578 6.50033 4.83268 6.87342 4.83268 7.33366C4.83268 7.7939 5.20578 8.16699 5.66602 8.16699Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M9.83268 7.33366C9.83268 7.7939 9.45959 8.16699 8.99935 8.16699C8.53911 8.16699 8.16602 7.7939 8.16602 7.33366C8.16602 6.87342 8.53911 6.50033 8.99935 6.50033C9.45959 6.50033 9.83268 6.87342 9.83268 7.33366Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M12.3327 8.16699C12.7929 8.16699 13.166 7.7939 13.166 7.33366C13.166 6.87342 12.7929 6.50033 12.3327 6.50033C11.8724 6.50033 11.4993 6.87342 11.4993 7.33366C11.4993 7.7939 11.8724 8.16699 12.3327 8.16699Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.16602 0.666992C1.7853 0.666992 0.666016 1.78628 0.666016 3.16699V11.5281C0.666016 12.9088 1.7853 14.0281 3.16602 14.0281H4.41602V16.5003C4.41602 16.8132 4.59123 17.0997 4.86973 17.2422C5.14822 17.3847 5.48307 17.3592 5.73681 17.1762L10.1018 14.0281H14.8327C16.2134 14.0281 17.3327 12.9088 17.3327 11.5281V3.16699C17.3327 1.78628 16.2134 0.666992 14.8327 0.666992H3.16602ZM2.33268 3.16699C2.33268 2.70675 2.70578 2.33366 3.16602 2.33366H14.8327C15.2929 2.33366 15.666 2.70676 15.666 3.16699V11.5281C15.666 11.9883 15.2929 12.3614 14.8327 12.3614H9.83268C9.6577 12.3614 9.48715 12.4165 9.34522 12.5189L6.08268 14.8719V13.1948C6.08268 12.7345 5.70959 12.3614 5.24935 12.3614H3.16602C2.70578 12.3614 2.33268 11.9883 2.33268 11.5281V3.16699Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ]))
}